const updates = [
  {
    time: '2小时前',
    tag: '娱乐圈',
    title: '某知名男歌手深夜密会照片遭曝光，经纪人紧急回应',
    hot: true,
  },
  {
    time: '4小时前',
    tag: '网红圈',
    title: '千万粉美食博主翻车：虚假宣传食材来源引众怒',
    hot: true,
  },
  {
    time: '6小时前',
    tag: '体育圈',
    title: '退役运动员实名举报国家队选拔黑幕材料持续披露',
    hot: false,
  },
  {
    time: '9小时前',
    tag: '金融圈',
    title: '某私募基金"跑路"内幕：投资者维权群人数突破千人',
    hot: false,
  },
  {
    time: '12小时前',
    tag: '直播圈',
    title: '平台一姐与公会解约纠纷升级，双方各执一词对簿公堂',
    hot: false,
  },
  {
    time: '16小时前',
    tag: '科技圈',
    title: 'AI初创公司核心算法涉嫌抄袭开源项目证据链公布',
    hot: false,
  },
  {
    time: '20小时前',
    tag: '娱乐圈',
    title: '某剧组拍摄现场发生安全事故，多人受伤内幕调查',
    hot: false,
  },
  {
    time: '1天前',
    tag: '社会热点',
    title: '多地消费者集体投诉某品牌产品质量问题持续发酵',
    hot: false,
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-900 mb-3">最新快讯</h2>
          <p className="text-foreground-500 text-sm max-w-xl mx-auto">黑料动态实时更新，第一时间掌握最新爆料进展</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 border-l-2 border-background-200/70">
            {updates.map((item, i) => (
              <div key={i} className="relative mb-6 last:mb-0 group cursor-pointer">
                <div
                  className={`absolute -left-[33px] top-1 w-4 h-4 rounded-full border-2 ${
                    item.hot
                      ? 'bg-primary-500 border-primary-500'
                      : 'bg-background-50 border-background-300/60'
                  }`}
                />

                <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                  <span className="text-xs text-foreground-400 font-medium">{item.time}</span>
                  <span
                    className={`px-2 py-0.5 rounded-md text-xs font-medium ${
                      item.hot ? 'bg-primary-100 text-primary-600' : 'bg-background-100 text-foreground-500'
                    }`}
                  >
                    {item.tag}
                  </span>
                  {item.hot && (
                    <span className="inline-flex items-center gap-0.5 text-xs text-accent-600 font-medium">
                      <i className="ri-fire-line" />
                      热门
                    </span>
                  )}
                </div>
                <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors leading-relaxed">
                  {item.title}
                </h3>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}